import { formatNumber } from './formatNumber';

export const formatKpi = (value: any = 0) => {
  if (value === 0) {
    return 'Unlimited'
  }
  return formatNumber(value);
};
